module.exports = __webpack_public_path__ + "static/media/calendar.4da0dfab.svg";